import { Button, Flex, theme } from 'antd';

import BaseText from '@components/typography/BaseText';

import { objectCountLabel } from '../collectionTree';
import ObjectRow from './ObjectRow';
import PanelEyebrow from './PanelEyebrow';

/**
 * The right panel in list mode: a prompt until a collection is selected, then
 * its objects. Object rows are not links yet — the Objects page has no details
 * view to open one in.
 *
 * @param {{ id, name, objects: Array<{ key, label, color?, path }> } | null} props.collection
 * @param {(collection) => void} [props.onEdit] - omitted when the viewer can't edit it
 */
const CollectionDetails = ({ collection, onEdit }) => {
	const { token } = theme.useToken();

	if (!collection) {
		return (
			<Flex
				vertical
				align="center"
				gap="small"
				style={{ marginTop: token.marginXXL, textAlign: 'center' }}>
				<PanelEyebrow>COLLECTION DETAILS</PanelEyebrow>
				<BaseText size="sm" type="secondary">
					Select a collection to see its objects
					<br />
					and where it can be used.
				</BaseText>
			</Flex>
		);
	}

	return (
		<Flex vertical gap="small" style={{ height: '100%', minHeight: 0 }}>
			<PanelEyebrow>COLLECTION</PanelEyebrow>
			<BaseText strong>{collection.name}</BaseText>
			<BaseText size="xs" type="secondary">
				{objectCountLabel(collection.objects.length)}
			</BaseText>

			<Flex
				vertical
				gap="small"
				style={{ marginTop: token.marginXXS, overflowY: 'auto', minHeight: 0 }}>
				{collection.objects.map(object => (
					<ObjectRow key={object.key} object={object} />
				))}
			</Flex>

			{onEdit && (
				<Button block onClick={() => onEdit(collection)} style={{ marginTop: 'auto' }}>
					Edit collection
				</Button>
			)}
		</Flex>
	);
};

export default CollectionDetails;
